/**
 * Orders Empty State Component
 */

import { TableEmptyState } from '@spcc/uikit'
import { ShoppingCart } from '@spcc/uikit'
import { useTranslation } from '@spcc/core'

export function OrdersEmptyState() {
  const { t } = useTranslation()

  return (
    <div className="glass-card rounded-2xl overflow-hidden">
      <TableEmptyState
        icon={ShoppingCart}
        title={t('orders.noOrders')}
        description={t('orders.noOrdersDescription')}
      />
    </div>
  )
}
